/**
 * Allure dashboard API base URL (same contract as allure_account-new).
 */
export function getApiEndpoint(shopDomain) {
  if (!shopDomain && typeof window !== "undefined") {
    const hostname = window.location.hostname;
    if (hostname.includes(".myshopify.com")) {
      shopDomain = hostname;
    } else {
      return "https://apps.allurecommerce.com:9096";
    }
  }
  if (!shopDomain) {
    return "https://apps.allurecommerce.com:9096";
  }
  const shop = shopDomain.replace(/\.myshopify\.com$/i, "").toLowerCase();
  if (shop === "gatlinburg-winery-staging" || shop === "gatlinburg-winery") {
    return "https://apps.allurecommerce.com:9093";
  }
  return "https://apps.allurecommerce.com:9096";
}

export function getApiUrl(shopDomain = null, path) {
  const baseUrl = getApiEndpoint(shopDomain);
  return `${baseUrl}${path}`;
}
